// extracted by mini-css-extract-plugin
module.exports = {"AccordionList__list":"AccordionList_AccordionList__list__Yfm9b","AccordionList__listItem":"AccordionList_AccordionList__listItem__hpJJz"};